import { C } from "./const";

const SectionBadge = ({ text }: { text: string }) => (
    <span
        style={{
            display: "inline-block",
            background: C.primaryLight,
            color: C.primary,
            padding: "5px 16px",
            borderRadius: 20,
            fontSize: 13,
            fontWeight: 600,
            marginBottom: 14,
        }}
    >
        {text}
    </span>
);


export default SectionBadge;